import Api from '../http.service';

/**
 * Fetch all Business Group Types
 */
export const getAllBusinessGroup = () => Api.GET({ url: 'profile_type/all' });

/**
 * GET ALL Profile Types
 */
export const getAll = () => Api.GET({ url: 'profile_type' });
